// actions/connect/sources.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectSourcesHasErrored(bool) {
  return {
    type: 'CONNECT_SOURCES_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectSourcesIsLoading(bool) {
  return {
    type: 'CONNECT_SOURCES_IS_LOADING',
    isLoading: bool
  };
}

export function connectSourcesFetchDataSuccess(list) {
  return {
    type: 'CONNECT_SOURCES_FETCH_DATA_SUCCESS',
    list
  };
}

export function connectSourcesFetchData(host, me) {
  var meStr = '';
  if (me) {
    meStr = '?me';
  }
  return (dispatch) => {
    dispatch(connectSourcesIsLoading(true));
    dispatch(connectSourcesHasErrored(false));
    fetch(host + 'connect/sources' + meStr, {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectSourcesFetchDataSuccess(result));
            dispatch(connectSourcesHasErrored(false));
            dispatch(connectSourcesIsLoading(false));
            PubSub.publish('connect.chat.sources', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectSourcesHasErrored(true));
            dispatch(connectSourcesIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectSourcesHasErrored(true));
      dispatch(connectSourcesIsLoading(false));
    });
  };
}